import axios from 'axios'
import apiURI from './Api';

export default class UserEditService {
  async postChangeProfilePicture(token, image, username) {
    let data = new FormData();
    data.append('image', image);

    const response = await axios({ method: 'post', url: `${apiURI}/user/uploadavatar?username=${username}`, data: data, 
    headers: { 'Authorization': 'Bearer ' + token } });
    return response.data;
  }

  async postChangeProfileInfo(token, userEditJSON) {
    const response = await axios({ method: 'post', url: `${apiURI}/user/editprofile`, 
    data: userEditJSON, headers: { 'Authorization': 'Bearer ' + token } });
    return response.data;
  }

  async getAllUserWithdrawRequests(token, username) {
    const response = await axios({
      method: 'get', url: `${apiURI}/withdraw/listbyuser/${username}`,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async postProcessUserWithdraw(token, withdrawId, username) {
    const bodyJson = {
      idwithdraw: withdrawId,
      user: { username: username }
    }

    const response = await axios({
      method: 'post', url: `${apiURI}/withdraw/process`, data: bodyJson,
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }
}